import { render, staticRenderFns } from "./LoginWrapper.vue?vue&type=template&id=66080056&scoped=true"
var script = {}
import style0 from "./LoginWrapper.vue?vue&type=style&index=0&id=66080056&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66080056",
  null
  
)

export default component.exports